import React from 'react';
import {
    Box,
    Grid,
    IconButton,
    TextField,
    Tooltip,
    Button,
    Typography
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useStudio } from '../../Context/StudioContext';

const SlotTimeSchedule = () => {
    const { formData, setFormData } = useStudio();
    const showRSVP = formData.showRSVP;
    const showSlotTime = formData.showSlotTime;

    const handleSlotChange = (index, field, value) => {
        // Ensure numeric fields accept only positive numbers
        if (['guestPerPax', 'totalGuest'].includes(field)) {
            // Allow empty string so user can clear input, and block negatives
            if (value === '' || (/^\d+$/.test(value) && Number(value) >= 0)) {
                updateSlotField(index, field, value);
            }
        } else {
            updateSlotField(index, field, value);
        }
    };

    const updateSlotField = (index, field, value) => {
        const updated = [...(formData.slotTimes || [])];
        updated[index][field] = value;
        setFormData(prev => ({ ...prev, slotTimes: updated }));
    };

    const addSlot = () => {
        setFormData(prev => ({
            ...prev,
            slotTimes: [...(prev.slotTimes || []), { slotTimeStart: '', label: '' }]
        }));
    };

    const removeSlot = (index) => {
        const updated = [...(formData.slotTimes || [])];
        updated.splice(index, 1);
        setFormData(prev => ({ ...prev, slotTimes: updated }));
    };

    return (
        <Box sx={{ width: '100%', mt: 1 }}>
            {(formData.slotTimes || []).map((slot, index) => (
                <Box
                    key={index}
                    sx={{
                        mb: 3,
                        p: 2,
                        border: '1px solid #eee',
                        borderRadius: '8px',
                    }}
                >
                    {/* Header: Title */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            Slot {index + 1}
                        </Typography>
                    </Box>

                    {/* Responsive Grid for fields */}
                    <Grid container spacing={2}>
                        {/* Time pickers side by side on mobile, and next to label on desktop */}
                        <Grid item xs={6} sm={3}>
                            <TextField
                                fullWidth
                                label="Mula"
                                value={slot.slotTimeStart || ''}
                                type="time"
                                disabled={showRSVP || !showSlotTime}
                                onChange={(e) => handleSlotChange(index, 'slotTimeStart', e.target.value)}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={6} sm={3}>
                            <TextField
                                fullWidth
                                label="Tamat"
                                value={slot.slotTimeEnd || ''}
                                type="time"
                                disabled={showRSVP || !showSlotTime}
                                onChange={(e) => handleSlotChange(index, 'slotTimeEnd', e.target.value)}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Slot Tetamu"
                                disabled={showRSVP || !showSlotTime}
                                value={slot.label || ''}
                                onChange={(e) => handleSlotChange(index, 'label', e.target.value)}
                                placeholder="Keluarga"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        {/* Number limits stacked on mobile, side by side on desktop */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Had Kehadiran per Tetamu"
                                disabled={showRSVP || !showSlotTime}
                                value={slot.guestPerPax || ''}
                                onChange={(e) => handleSlotChange(index, 'guestPerPax', e.target.value)}
                                placeholder="4"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Keseluruhan Tetamu per Slot"
                                disabled={showRSVP || !showSlotTime}
                                value={slot.totalGuest || ''}
                                onChange={(e) => handleSlotChange(index, 'totalGuest', e.target.value)}
                                placeholder="100"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        mt={2}
                        sx={{ width: '100%' }}
                    >
                        <Tooltip title={"Remove slot"}>
                            <IconButton
                                onClick={() => removeSlot(index)}
                                size="small"
                                sx={{ color: '#d32f2f' }}
                                disabled={formData.slotTimes.length === 1}
                            >
                                <RemoveCircleOutlineIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Add slot">
                            <IconButton
                                size="small"
                                onClick={addSlot}
                                color="primary"
                                disabled={showRSVP || !showSlotTime}
                            >
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Box>
            ))}
        </Box>
    );
};

export default SlotTimeSchedule;
